<template>
  <div>
    <Dialog
      :visible="renderData.visible"
      @close="closeDialog"
      height="90%"
      mobileRenderType="drawerDialog"
      customClass="choose-model-dialog"
    >
      <div class="choose-model-box">
        <div class="title olh">{{ current_model?.display_name }}</div>
        <div class="content-container">
          <!-- 可滚动部分 -->
          <div class="scrollable-content" ref="scrollContainerRef">
            <div
              class="model-crad"
              v-for="item in model_list"
              :key="item.model"
              @click="handleSelect(item)"
              :data-model-id="item.model"
            >
              <div class="flex-space-between w-all">
                <div class="flex flex1 width-0" style="padding-right: 6px">
                  <div
                    class="name olh"
                    :class="{
                      'model-name-used': item.model == current_model?.model,
                    }"
                  >
                    {{ item.display_name }}
                  </div>
                  <div
                    v-if="item.free_to_use == 1"
                    class="flex-center free-flag"
                  >
                    首次免费
                  </div>
                </div>
                <img
                  v-if="item.model == current_model?.model"
                  class="select"
                  src="@/assets/img/lora/has-selected.png"
                  alt=""
                />
                <img
                  v-else
                  class="select"
                  src="@/assets/img/lora/no-select.png"
                  alt=""
                />
              </div>
              <div class="required-credits">
                {{
                  $t("create.credit_per_song", {
                    credit: item.required_credits,
                    amount: item.generation_amount,
                  })
                }}
              </div>
              <div class="desc">{{ item.description }}</div>
            </div>
            <div
              class="model-crad"
              v-for="item in lora_model_list"
              :key="item.model"
              @click="
                handleSelect({
                  ...item,
                  uid: userInfo?.user?.id,
                })
              "
              :data-model-id="item.model"
            >
              <div class="flex-space-between">
                <div
                  class="name"
                  :class="{
                    'model-name-used': item.model == current_model?.model,
                  }"
                >
                  {{ item.display_name }}
                </div>
                <img
                  v-if="item.model == current_model?.model"
                  class="select"
                  src="@/assets/img/lora/has-selected.png"
                  alt=""
                />
                <img
                  v-else
                  class="select"
                  src="@/assets/img/lora/no-select.png"
                  alt=""
                />
              </div>
              <div class="required-credits">
                {{
                  $t("create.credit_per_song", {
                    credit: item.required_credits,
                    amount: item.generation_amount,
                  })
                }}
              </div>
            </div>
          </div>

          <!-- 固定部分保持不变 -->
          <div class="fixed-content" v-if="ModuleOpenStateControl.model.custom">
            <div v-if="[1, 2, 4].includes(lora_state)" class="model-state">
              <div class="flex">
                <div class="name flex1 olh">{{ show_modle.display_name }}</div>
                <div v-if="lora_state == 1" class="wait-tip">
                  {{ $t("create.in_the_queue", { wait_num }) }}
                </div>
                <div
                  v-else-if="lora_state == 2"
                  class="flex-center generating-tip"
                >
                  <LoaderCircle
                    :loading="true"
                    :size="14"
                    :strokeWidth="1"
                    color="#fff"
                  />
                  <div class="text">{{ $t("create.in_training") }}</div>
                </div>
                <div class="fail-tip" v-else>
                  {{ $t("create.model_training_error") }}
                </div>
              </div>
              <div class="show">
                <div v-if="lora_state == 1" class="wait-line"></div>
                <div v-else-if="lora_state == 2" class="generating-line">
                  <div
                    class="generating-line-progress"
                    :style="{ width: generating_progress + '%' }"
                  ></div>
                </div>
                <div v-else class="fail-box flex">
                  <div class="pointer flex-center" @click="handleRestore">
                    <img
                      v-if="!restoreLoading"
                      src="@/assets/img/lora/restore.png"
                      alt=""
                    />
                    <LoaderCircle
                      v-else
                      :loading="true"
                      :size="16"
                      :strokeWidth="1"
                      color="#fff"
                    />
                  </div>
                  <div class="pointer flex-center" @click="handleCancel">
                    <img
                      v-if="!cancelLoading"
                      src="@/assets/img/lora/del.png"
                      alt=""
                    />
                    <LoaderCircle
                      v-else
                      :loading="true"
                      :size="16"
                      :strokeWidth="1"
                      color="#fff"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div
              v-if="![1, 2, 4].includes(lora_state)"
              class="model-card-add flex"
              @click="handleAdd"
            >
              <div class="add-flag">
                <img src="@/assets/img/lora/add.png" alt="" />
              </div>
              <div class="desc flex-center">
                {{ $t("create.create_model") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script setup>
import {
  defineProps,
  defineEmits,
  reactive,
  watch,
  ref,
  getCurrentInstance,
  onMounted,
  onUnmounted,
  nextTick,
} from "vue";
import { storeToRefs } from "pinia";
import { ModuleOpenStateControl } from "@/config/config.js";
import useModelDataStore from "@/store/model/modelDataStore.js";
import useUserDataStore from "@/store/userDataStore";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
import tools from "@/utils/tools.js";

const globalProperties =
  getCurrentInstance()?.appContext.config.globalProperties;
const userDataStore = useUserDataStore();
const modelDataStore = useModelDataStore();
const createLayoutStore = useCreateLayoutStore();

// 存储引用
const scrollContainerRef = ref(null);
const visibleModels = ref(new Set());
let observer = null;

const {
  lora_state,
  model_list,
  lora_model_list,
  current_model,
  show_modle,
  generating_progress,
  wait_num,
} = storeToRefs(modelDataStore);
const { userInfo } = storeToRefs(userDataStore);
const { createEditMode } = storeToRefs(createLayoutStore);

const emits = defineEmits([
  "handleRestore",
  "handleCancel",
  "handleAddModel",
  "update:visible",
  "handleSelectModel",
]);
const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  restoreLoading: {
    type: Boolean,
    default: false,
  },
  cancelLoading: {
    type: Boolean,
    default: false,
  },
});

const renderData = reactive({
  visible: false,
});

// 初始化 IntersectionObserver
const initIntersectionObserver = () => {
  if (!scrollContainerRef.value) {
    return;
  }

  observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        const modelId = entry.target.getAttribute("data-model-id");
        if (entry.isIntersecting) {
          visibleModels.value.add(modelId);
        } else {
          visibleModels.value.delete(modelId);
        }
      });
    },
    {
      threshold: 0.1, // 10%可见即认为可见
      root: scrollContainerRef.value,
    }
  );
  document.querySelectorAll(".model-crad[data-model-id]").forEach((el) => {
    observer.observe(el);
  });
};

// 防抖处理滚动事件
const handleScroll = tools.debounce(() => {
  logVisibleModels();
}, 200);

// 记录可见模型
const logVisibleModels = () => {
  const visibleIds = Array.from(visibleModels.value);
  globalProperties.logCustomEvent("create_model_list_show", {
    sources: visibleIds,
    tab_stare: createEditMode.value == "easy" ? "basic" : "advanced",
  });
};

// 组件挂载时初始化
onMounted(async () => {
  await nextTick(); // 等待DOM更新
  if (scrollContainerRef.value) {
    scrollContainerRef.value.addEventListener("scroll", handleScroll);
    initIntersectionObserver();
  }
});

// 组件卸载时清理
onUnmounted(() => {
  if (observer) {
    observer.disconnect();
  }
  if (scrollContainerRef.value) {
    scrollContainerRef.value.removeEventListener("scroll", handleScroll);
  }
});

// 对话框可见性变化时处理
watch(
  () => props.visible,
  async (val) => {
    renderData.visible = val;
    if (val) {
      await nextTick();
      // 重新初始化观察器以确保捕捉所有元素
      nextTick().then(() => {
        if (observer) observer.disconnect();
        initIntersectionObserver();
        setTimeout(() => {
          logVisibleModels()
        },2000)
      });
    }
  },
  { immediate: true }
);

// 其他方法保持不变
const closeDialog = () => {
  renderData.visible = false;
};

const handleRestore = () => {
  emits("handleRestore");
};

const handleCancel = () => {
  emits("handleCancel");
};

const handleAdd = () => {
  emits("handleAddModel");
};

const handleSelect = (item) => {
  emits("handleSelectModel", item);
};
</script>

<style lang="scss" scoped>
.choose-model-dialog {
  .choose-model-box {
    padding: 0 16px 20px;
    height: 100%;
    display: flex;
    flex-direction: column;
    .title {
      padding-right: 24px;
      color: #fff;
      font-size: 24px;
      font-weight: 500;
      line-height: 36px;
      margin-bottom: 20px;
    }

    .content-container {
      flex: 1;
      display: flex;
      flex-direction: column;
      overflow: hidden;

      .scrollable-content {
        flex: 1;
        overflow-y: auto;
        // margin-bottom: 12px;

        .model-crad {
          color: #fff;
          padding: 20px;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.1);
          margin-bottom: 12px;
          &:last-of-type {
            margin-bottom: 0;
          }
          .name {
            font-size: 16px;
            font-weight: bold;
            &-used {
              color: #94adff;
            }
          }
          .free-flag {
            flex-shrink: 0;
            margin-left: 8px;
            height: 18px;
            font-size: 9px;
            line-height: 18px;
            padding: 2px 6px;
            background: linear-gradient(
              113deg,
              #ffe08b -1%,
              #fff7d0 47%,
              #ffe08b 100%
            );
            border-radius: 20px;
            color: #000;
          }
          .select {
            width: 20px;
            height: 20px;
          }

          .required-credits {
            margin-top: 6px;
            font-size: 12px;
            line-height: 120%;
            color: rgba(255, 255, 255, 0.5);
          }

          .desc {
            margin-top: 6px;
            font-size: 12px;
            line-height: 150%;
            color: rgba(255, 255, 255, 0.8);
          }
        }
      }

      .fixed-content {
        // margin-top: 12px;
        flex-shrink: 0;

        .model-state {
          padding: 20px;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.1);

          .name {
            font-size: 20px;
            font-weight: bold;
            color: rgba(255, 255, 255, 0.5) !important;
          }

          .fail-tip {
            font-size: 14px;
            color: #ff5f74;
            margin-left: 8px;
          }

          .wait-tip {
            font-size: 14px;
            color: #fff;
            margin-left: 8px;
          }

          .generating-tip {
            margin-left: 8px;
            font-size: 14px;
            color: #fff;

            .text {
              margin-left: 4px;
            }
          }

          .show {
            margin-top: 8px;

            .wait-line {
              animation: opacityAnimation 1.8s infinite;
              border-radius: 4px;
              width: 100%;
              height: 18px;
              background: rgba(255, 255, 255, 0.2);
            }

            .generating-line {
              position: relative;
              border-radius: 4px;
              width: 100%;
              height: 18px;
              background: rgba(255, 255, 255, 0.2);
              overflow: hidden;

              .generating-line-progress {
                position: absolute;
                top: 0;
                bottom: 0;
                left: 0;
                background: linear-gradient(101deg, #4fdeff 0%, #e675ff 100%);
              }
            }

            .fail-box {
              justify-content: space-between;

              > div {
                border-radius: 60px;
                width: calc((100% - 6px) / 2);
                height: 32px;
                background: rgba(255, 255, 255, 0.1);

                img {
                  width: 16px;
                  height: 16px;
                }
              }
            }
          }
        }

        .model-card-add {
          margin-top: 12px;
          padding: 12px;
          border-radius: 16px;
          background: rgba(255, 255, 255, 0.1);

          .add-flag {
            padding: 16px;
            background: rgba(255, 255, 255, 0.1);
            border-radius: 12px;

            img {
              display: block;
              width: 20px;
              height: 20px;
            }
          }

          .desc {
            margin: 0 0 0 16px;
            font-size: 12px;
            line-height: 150%;
            color: #fff;
          }
        }
      }
    }
  }
}
</style>